import { Card, Col, Row } from "antd";
import React from "react";
import { memo } from "react";

const TmsDisplayCard = ({ label, card, i, router }) => {
  return (
    <Col
      key={label + "-booking-cards" + i}
      style={{
        float: "left",
        width:
          window.innerWidth < 650
            ? "100%"
            : window.innerWidth < 1000 && window.innerWidth > 650
            ? "50%"
            : "33%",
      }}
    >
      <Card
        hoverable
        className="antd-custom"
        style={{
          backgroundColor: "#ffffff",
          color: "#804419",
          borderRadius: "20px",
          padding: "15px",
          display: "flex",
          width: "100%",
        }}
        onClick={() => router.navigate(card.route)}
      >
        <img
          src={card.logo}
          alt={"Logo"}
          style={{
            padding: "6px",
            borderRadius: "50%",
            backgroundColor: "#fff",

            boxSizing: "border-box",
          }}
        />
        <Row
          style={{
            fontSize: "20px",
            textAlign: "center",
            display: "block",
          }}
        >
          {card.title}
        </Row>
      </Card>
    </Col>
  );
};
export default memo(TmsDisplayCard);
